/**
 * @generated SignedSource<<86f6f059d2bd0d210f29716b25141cea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Project_portfolioProject$data = {
  readonly __typename: "PortfolioProject";
  readonly analyticsId: number;
  readonly author: {
    readonly avatarImage: {
      readonly id: string;
      readonly uid: string;
      readonly url: string;
    } | null;
    readonly displayUsername: string;
    readonly firstName: string | null;
    readonly id: string;
    readonly lastName: string | null;
    readonly title: string | null;
  } | null;
  readonly blocknoteContent: ContraAPIScalars.JSON | null;
  readonly collaborators: {
    readonly count: number;
  };
  readonly contributionYear: number | null;
  readonly id: string;
  readonly publishedAt: ContraAPIScalars.DateTime | null;
  readonly roles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string;
      };
    }>;
  };
  readonly slug: string;
  readonly title: string;
  readonly tools: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly logoImage: {
          readonly uid: string;
          readonly url: string;
        } | null;
        readonly name: string;
      };
    }>;
  };
  readonly visitorCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectExpandedCollaboratorsList_portfolioProject" | "ProjectMinimizedCollaboratorsList_portfolioProject" | "ProjectRolesToolsOrganizations_portfolioProject">;
  readonly " $fragmentType": "Project_portfolioProject";
};
export type Project_portfolioProject$key = {
  readonly " $data"?: Project_portfolioProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"Project_portfolioProject">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uid",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Project_portfolioProject",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "analyticsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contributionYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PortfolioProjectCollaboratorConnection",
      "kind": "LinkedField",
      "name": "collaborators",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blocknoteContent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PortfolioProjectRoleConnection",
      "kind": "LinkedField",
      "name": "roles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PortfolioProjectRoleEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Role",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PortfolioProjectToolConnection",
      "kind": "LinkedField",
      "name": "tools",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PortfolioProjectToolEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Tool",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ContraImage",
                  "kind": "LinkedField",
                  "name": "logoImage",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/),
                    (v4/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayUsername",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ContraImage",
          "kind": "LinkedField",
          "name": "avatarImage",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v4/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectMinimizedCollaboratorsList_portfolioProject"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectExpandedCollaboratorsList_portfolioProject"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectRolesToolsOrganizations_portfolioProject"
    }
  ],
  "type": "PortfolioProject",
  "abstractKey": null
};
})();

(node as any).hash = "2118d0bb952f76f085d5eb8c94641215";

export default node;
